import React from 'react';
import { useTranslation } from 'react-i18next';

const ProgressBar = ({ isConverting, progress }) => {
  const { t } = useTranslation();
  
  if (!isConverting) {
    return null;
  }

  return (
    <div className="conversion-progress" style={{ marginBottom: '20px' }}>
      <div className="progress-header">
        <div className="progress-info">
          <span className="progress-text">
            {t('progress.converting', { current: progress.currentFileIndex, total: progress.totalFiles })}
          </span>
          <span className="progress-percentage">
            {Math.round(progress.overallProgress)}%
          </span>
        </div>
      </div>
      
      <div className="progress-bar-container">
        <div className="progress-bar">
          <div 
            className="progress-fill" 
            style={{ width: `${progress.overallProgress}%` }}
          ></div>
        </div>
      </div>
      
      {progress.currentFile && (
        <div className="current-file-info">
          <div className="current-file-name">
            {t('progress.current', { filename: progress.currentFile })}
          </div>
          {progress.fileProgress > 0 && (
            <div className="file-progress-bar">
              <div className="file-progress-fill" style={{ width: `${progress.fileProgress}%` }}></div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
